import React, { Component } from "react";
import { connect } from "react-redux";
import { getProductsByCategory } from "../../store/actions/product";
import { setCategory, getCategoryBySlug } from "../../store/actions/category";
import PageTitle from "../../components/shared/PageTitle";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import CartWidget from "../../components/shared/CartWidget";

import Loading from "../../components/shared/Loading";

class Page extends Component {
  state = { page: null };
  componentDidMount() {
    this.setState(
      {
        page: this.props.page.page.find(
          ({ slug }) => slug === this.props.match.params.slug
        )
      },
      () => {
        window.scrollTo(0, 0);
      }
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.match.params.slug !== prevProps.match.params.slug) {
      this.setState(
        {
          page: this.props.page.page.find(
            ({ slug }) => slug === this.props.match.params.slug
          )
        },
        () => {
          window.scrollTo(0, 0);
        }
      );
    }
  }

  render() {
    return (
      <React.Fragment>
        <PageTitle title={this.state.page && this.state.page.menu_title} />
        <div className="row">
          <div className={"container"}>
            <div className="row">
              <div className={"col-md-9"}>
                <div
                  className={"row"}
                  style={{ marginTop: 20, marginBottom: 50 }}
                >
                  <h3 style={{ width: "100%" }}>
                    {this.state.page && this.state.page.content_title}
                  </h3>
                  <div
                    style={{ width: "100%" }}
                    dangerouslySetInnerHTML={{
                      __html: this.state.page && this.state.page.content
                    }}
                  />
                </div>
              </div>
              <div className={"col-md-3"}>
                <CartWidget />
                <CategoriesWidget />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ page }) => {
  return { page };
};

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Page);



// WEBPACK FOOTER //
// ./src/routers/Page/index.js